import { RECURRENCE_LIMITS } from '../constants/Expenses';
import { toCalendarDateKey } from './dateFormatUtils';

const parseDateKey = (value) => {
  const match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) {
    return null;
  }

  const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  return Number.isNaN(date.getTime()) ? null : date;
};

export const addMonthsClamped = (date, months) => {
  const day = date.getDate();
  const target = new Date(date.getFullYear(), date.getMonth() + months, 1);
  const lastDay = new Date(target.getFullYear(), target.getMonth() + 1, 0).getDate();
  target.setDate(Math.min(day, lastDay));
  return target;
};

const addInterval = (anchor, frequency, steps) => {
  if (frequency === 'Weekly') {
    const next = new Date(anchor);
    next.setDate(next.getDate() + (steps * 7));
    return next;
  }

  if (frequency === 'Yearly') {
    return addMonthsClamped(anchor, steps * 12);
  }

  return addMonthsClamped(anchor, steps);
};

const addYears = (date, years) => {
  const next = new Date(date);
  next.setFullYear(next.getFullYear() + years);
  return next;
};

export const listOccurrenceDates = ({
  startDate,
  frequency,
  intervalCount = 1,
  endMode = 'Never',
  occurrenceCount,
  endDate,
} = {}) => {
  const anchor = parseDateKey(startDate);
  if (!anchor || !frequency) {
    return [];
  }

  const interval = Math.max(1, Number(intervalCount) || 1);
  const horizon = addYears(anchor, RECURRENCE_LIMITS.maxYears);
  const endBoundary = endMode === 'OnDate' ? parseDateKey(endDate) : null;
  const requestedCount = endMode === 'AfterCount'
    ? Number(occurrenceCount)
    : RECURRENCE_LIMITS.maxOccurrences;
  const limit = Math.min(
    RECURRENCE_LIMITS.maxOccurrences,
    Number.isInteger(requestedCount) && requestedCount > 0 ? requestedCount : 0,
  );
  const dates = [];

  for (let index = 0; index < limit; index += 1) {
    const next = addInterval(anchor, frequency, index * interval);
    if (next > horizon) {
      break;
    }

    if (endBoundary && next > endBoundary) {
      break;
    }

    dates.push(toCalendarDateKey(next));
  }

  return dates;
};
